export default __webpack_public_path__ + "static/media/footprint.6564ed5a.svg";